<template>
  <div class="reportStepWrapper">
    <PowerbiReport
      v-if="cockpitReport"
      :reportId="reportId"
      :workspaceId="workspaceId"
      :venueFilterColumn="cockpitReport.venueFilterColumn"
      :venueFilterTable="cockpitReport.venueFilterTable"
      :venueFilter="cockpitReport.venueFilter"
      :showLoading="false"
      :showNavbar="cockpitReport.showNavbar"
      :fitToWidth="shouldFitToWidth"
      :permission="cockpitReport.permission"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PowerbiReport from "@/components/PowerbiReport";

export default {
  data() {
    return {
      workspaceId: "",
      reportId: "",
      cockpitReport: null,
    };
  },
  components: { PowerbiReport },
  methods: {},
  computed: {
    ...mapGetters({
      reportDetails: "powerBi/reportDetails",
    }),
    shouldFitToWidth() {
      //- Cockpit report
      if( this.reportId === "39690035-ee3c-421b-b868-aeb8dbe6b7f2" || this.reportId == "240ff3de-8087-4e78-b27e-313ab4da6fbc") return true;

      //- Nightpay internal and external reports
      if (this.reportId == "e2a24815-971c-4e99-a3c3-bf3daeb51dd6" || this.reportId == "c11b9943-d7f0-409d-a163-5763c349478b") return true;
      return false;
    }
  },
  async created() {},
  async mounted() {
    const cockpitReportId = this.$route.params.id;

    //this.$vs.loading();
    this.cockpitReport =
      this.$store.getters["cockpitReports/cockpitReport"](cockpitReportId);

    console.log("Loading report for ", cockpitReportId);
    this.workspaceId = this.cockpitReport.workspaceId;
    this.reportId = this.cockpitReport.reportId;
  },
};
</script>

<style lang="scss" scoped>
.reportStepWrapper {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

/*   #powerbi-wrapper {
    aspect-ratio: 4/3;
    max-width: 100%;
  } */
}
</style>